module.exports = __webpack_public_path__ + "static/media/09-Karlsruhe@3x.2ed82d28.jpg";